import { useTranslation } from 'react-i18next';
import { IonButton, IonIcon } from '@ionic/react';
import { IonRouterLink } from '@ionic/react';
import { useState } from 'react';
import { personAddOutline } from 'ionicons/icons';
import { GolfAvatar } from '../ui/GolfAvatar';
import { api } from '@/utils/api';

type FriendRequestItemProps = {
  userId: string;
  friendshipId?: number;
  senderInfo: {
    name: string;
    username: string;
    avatar: string;
  };
};

export function FriendRequestNotification({ userId, friendshipId, senderInfo }: FriendRequestItemProps) {

  console.log("senderinfo is", senderInfo)
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [accepted, setAccepted] = useState(false);
  const [declined, setDeclined] = useState(false);

  // Confirm (Accept Friend Request) Action
  const handleAccept = async () => {
    try {
      setLoading(true);

      if (!friendshipId) {
        console.error('Missing friendship ID');
        return;
      }

      const response = await api.put(`/friendships`, { friendshipId });

      if (response.status === 200) {
        setAccepted(true);
      }
    } catch (err) {
      console.error(`Error while trying to accept friend request:`, err);
    } finally {
      setLoading(false);
    }
  };

  // Cancel (Decline Friend Request) Action
  const handleDecline = async () => {
    try {
      setLoading(true);

      if (!friendshipId) {
        console.error('Missing friendship ID');
        return;
      }

      const response = await api.delete('/friendships/', { data: { friendshipId } });

      if (response.status === 200) {
        setDeclined(true);
      }
    } catch (err) {
      console.error(`Error while trying to decline friend request:`, err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex space-x-3 py-4">
      {/* Notification icon on the left */}
      <div className="flex-shrink-0 mt-1">
        <div className="flex items-center justify-center size-8 rounded-full bg-primary/10">
          <IonIcon icon={personAddOutline} className="size-4 text-primary" />
        </div>
      </div>

      {/* Main content */}
      <div className="flex-1">
        <div className="flex items-start justify-between">
          {/* Sender info and text */}
          <div className="flex flex-col">
            <IonRouterLink href={`/u/${encodeURIComponent(senderInfo.username)}`}>
              <GolfAvatar
                imageUrl={senderInfo.avatar || '/assets/images/user.webp'}
                size={32}
              />
            </IonRouterLink>
            <p className="text-sm">
              <IonRouterLink href={`/u/${encodeURIComponent(senderInfo.username)}`} className="font-semibold hover:underline mr-1">
                {senderInfo.name}
              </IonRouterLink>
              {t('followed_you')}
            </p>

            {/* Action Buttons */}
            {!accepted && !declined && (
              <div className="flex gap-2 mt-2">
                <IonButton
                  disabled={loading}
                  size="small"
                  shape='round'
                  onClick={handleAccept}
                >
                  {loading ? '...' : t('follow_back')}
                </IonButton>
                <IonButton
                  color="secondary"
                  size="small"
                  disabled={loading}
                  shape="round"
                  onClick={handleDecline}
                >
                  {loading ? '...' : t('ignore')}
                </IonButton>
              </div>
            )}
            {accepted && (
              <div className="text-sm text-green-600 mt-2">
                {t('friend_request_accepted')}
              </div>
            )}
            {declined && (
              <div className="text-sm text-muted-foreground mt-2">
                {t('friend_request_declined')}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
